// Textes du site dans les 4 langues.
// Les noms de plats restent en espagnol (voir data/menu.js) : seules les
// descriptions, catégories et libellés sont traduits.

export const LANGS = [
  { code: "es", label: "ES", name: "Español", dir: "ltr", locale: "es-ES" },
  { code: "fr", label: "FR", name: "Français", dir: "ltr", locale: "fr-FR" },
  { code: "ar", label: "AR", name: "العربية", dir: "rtl", locale: "ar" },
  { code: "ru", label: "RU", name: "Русский", dir: "ltr", locale: "ru-RU" },
];

export const T = {
  es: {
    nav: {
      home: "Ir al inicio",
      menu: "Abrir menú",
      links: {
        "sobre-nosotros": "Nosotros",
        carta: "La Carta",
        favoritos: "Favoritos",
        galeria: "Galería",
        visitanos: "Visítanos",
        reserva: "Reservar",
      },
      lang: "Idioma",
    },
    hero: {
      title: "Empieza tu día como más te gusta",
      tagline: "Brunch & Specialty Coffee · Alicante",
      ctaMenu: "Ver la carta",
      ctaBook: "Reservar mesa",
    },
    about: {
      label: "Nuestra filosofía",
      title: "Mañanas lentas, café de verdad",
      p1a: "En Deseos trabajamos con café de especialidad ",
      p1strong: "100% arábica",
      p1b: ", tostado en pequeños lotes y extraído con el cuidado que merece. Cada taza es el resultado de una obsesión tranquila: el origen, el punto de tueste, la temperatura exacta.",
      p2: "Nuestra cocina abre cada mañana con ingredientes frescos del día — pan recién horneado, fruta de temporada, huevos, aguacate, salmón. Todo se prepara al momento, nada espera bajo una lámpara.",
      quote: "Hecho con amor, para ti.",
      stats: [
        ["100%", "Arábica"],
        ["9—18h", "Todos los días"],
        ["Al día", "Producto fresco"],
      ],
      altInterior: "Interior del café Deseos",
      altLatte: "Latte art de café de especialidad",
    },
    carta: { label: "La Carta", title: "Todo lo que se cocina a lo largo del día" },
    preparacion: {
      label: "Cada mañana",
      title1: "Nada esperando en la nevera",
      title2: "Capa a capa, cuando la pides",
      text: "Pan tostado del día, tomate rallado a mano, jamón cortado fino y huevo revuelto cremoso. Se monta en el momento, delante de ti. Por eso llega templado a la mesa.",
    },
    highlights: {
      label: "Los favoritos",
      title: "Lo que la gente vuelve a pedir",
      intro: "Cuatro platos que resumen bastante bien de qué va Deseos.",
      cards: [
        { k: "Dulce", t: "Bubble Waffle con helado", d: "Crujiente por fuera, esponjoso por dentro. Coronado con helado, nata y tu topping favorito." },
        { k: "Bebida", t: "Iced Matcha Latte", d: "Matcha batido al momento sobre leche fría y fruta natural. Fresco, herbal, adictivo." },
        { k: "Tostada", t: "Tostada de Aguacate", d: "Pan artesano, tomate fresco, aguacate en láminas y microbrotes." },
        { k: "Brunch", t: "Bocadillo con huevo", d: "Pan crujiente, huevo a la plancha, queso y verduras asadas." },
      ],
    },
    gallery: { label: "Galería", title: "Un rato en Deseos" },
    visit: {
      label: "Visítanos",
      title: "Te esperamos en Alicante",
      addressLabel: "Dirección",
      hoursLabel: "Horario",
      hoursEveryDay: "Todos los días",
      instagramLabel: "Instagram",
      mapsBtn: "Abrir en Google Maps",
      mapTitle: "Mapa de Deseos Brunch & Coffee en Alicante",
      altTerrace: "Entrada de Deseos Brunch & Coffee",
    },
    reserva: {
      label: "Reserva",
      title: "Guárdate una mesa",
      intro: "Los fines de semana la terraza se llena pronto. Dinos cuándo vienes y cuántos sois, y te dejamos sitio a la sombra.",
      nameLabel: "A nombre de",
      namePlaceholder: "Tu nombre",
      dayLabel: "Día",
      timeLabel: "Hora",
      peopleLabel: "Personas",
      peopleMore: "9 o más",
      noteLabel: "Algo que debamos saber",
      notePlaceholder: "Terraza, carrito, alergias…",
      send: "Enviar por WhatsApp",
      hint: "Se abrirá WhatsApp con el mensaje ya escrito. Solo tienes que enviarlo. Te confirmamos la mesa en cuanto lo leamos.",
      wa: {
        intro: "¡Hola! Me gustaría reservar una mesa en Deseos.",
        name: "Nombre",
        date: "Fecha",
        time: "Hora",
        people: "Personas",
        note: "Nota",
      },
    },
    entrada: {
      label: "Al final de la calle",
      title1: "Pasa, te esperamos",
      title2: "Y dentro, huele a café",
      text: "Entra cuando quieras. Abrimos todos los días a las nueve.",
      btn: "Cómo llegar",
    },
    footer: { hours: "Todos los días 9:00 – 18:00", credit: "Realizado por" },
  },

  fr: {
    nav: {
      home: "Retour en haut",
      menu: "Ouvrir le menu",
      links: {
        "sobre-nosotros": "À propos",
        carta: "La Carte",
        favoritos: "Les favoris",
        galeria: "Galerie",
        visitanos: "Nous trouver",
        reserva: "Réserver",
      },
      lang: "Langue",
    },
    hero: {
      title: "Commencez la journée comme vous l'aimez",
      tagline: "Brunch & Café de spécialité · Alicante",
      ctaMenu: "Voir la carte",
      ctaBook: "Réserver une table",
    },
    about: {
      label: "Notre philosophie",
      title: "Matins lents, vrai café",
      p1a: "Chez Deseos, nous travaillons un café de spécialité ",
      p1strong: "100 % arabica",
      p1b: ", torréfié en petits lots et extrait avec le soin qu'il mérite. Chaque tasse est le fruit d'une obsession tranquille : l'origine, le degré de torréfaction, la température exacte.",
      p2: "Notre cuisine ouvre chaque matin avec des produits frais du jour — pain tout juste sorti du four, fruits de saison, œufs, avocat, saumon. Tout est préparé à la commande, rien n'attend sous une lampe.",
      quote: "Fait avec amour, pour vous.",
      stats: [
        ["100%", "Arabica"],
        ["9h—18h", "Tous les jours"],
        ["Du jour", "Produits frais"],
      ],
      altInterior: "Intérieur du café Deseos",
      altLatte: "Latte art, café de spécialité",
    },
    carta: { label: "La Carte", title: "Tout ce qui se cuisine au fil de la journée" },
    preparacion: {
      label: "Chaque matin",
      title1: "Rien qui attend au frigo",
      title2: "Couche après couche, quand vous la commandez",
      text: "Pain grillé du jour, tomate râpée à la main, jambon coupé fin et œufs brouillés crémeux. Tout se monte sur le moment, devant vous. C'est pour ça que ça arrive encore tiède à table.",
    },
    highlights: {
      label: "Les favoris",
      title: "Ce que les gens redemandent",
      intro: "Quatre assiettes qui résument assez bien l'esprit Deseos.",
      cards: [
        { k: "Sucré", t: "Bubble Waffle con helado", d: "Croustillante dehors, moelleuse dedans. Couronnée de glace, de chantilly et du topping de votre choix." },
        { k: "Boisson", t: "Iced Matcha Latte", d: "Matcha fouetté à la minute sur un lait froid et des fruits frais. Frais, herbacé, addictif." },
        { k: "Tartine", t: "Tostada de Aguacate", d: "Pain artisanal, tomate fraîche, avocat en lamelles et jeunes pousses." },
        { k: "Brunch", t: "Bocadillo con huevo", d: "Pain croustillant, œuf à la plancha, fromage et légumes grillés." },
      ],
    },
    gallery: { label: "Galerie", title: "Un moment chez Deseos" },
    visit: {
      label: "Nous trouver",
      title: "On vous attend à Alicante",
      addressLabel: "Adresse",
      hoursLabel: "Horaires",
      hoursEveryDay: "Tous les jours",
      instagramLabel: "Instagram",
      mapsBtn: "Ouvrir dans Google Maps",
      mapTitle: "Carte de Deseos Brunch & Coffee à Alicante",
      altTerrace: "Entrée de Deseos Brunch & Coffee",
    },
    reserva: {
      label: "Réservation",
      title: "Gardez-vous une table",
      intro: "Le week-end, la terrasse se remplit vite. Dites-nous quand vous venez et combien vous êtes, on vous garde une place à l'ombre.",
      nameLabel: "Au nom de",
      namePlaceholder: "Votre nom",
      dayLabel: "Jour",
      timeLabel: "Heure",
      peopleLabel: "Personnes",
      peopleMore: "9 ou plus",
      noteLabel: "Quelque chose à nous signaler",
      notePlaceholder: "Terrasse, poussette, allergies…",
      send: "Envoyer par WhatsApp",
      hint: "WhatsApp s'ouvrira avec le message déjà écrit. Vous n'avez plus qu'à l'envoyer. On vous confirme la table dès qu'on le lit.",
      wa: {
        intro: "Bonjour ! Je souhaiterais réserver une table chez Deseos.",
        name: "Nom",
        date: "Date",
        time: "Heure",
        people: "Personnes",
        note: "Note",
      },
    },
    entrada: {
      label: "Au bout de la rue",
      title1: "Entre, on t'attend",
      title2: "Et dedans, ça sent le café",
      text: "Entrez quand vous voulez. On ouvre tous les jours à neuf heures.",
      btn: "Y aller",
    },
    footer: { hours: "Tous les jours 9:00 – 18:00", credit: "Réalisé par" },
  },

  ar: {
    nav: {
      home: "العودة إلى الأعلى",
      menu: "فتح القائمة",
      links: {
        "sobre-nosotros": "من نحن",
        carta: "القائمة",
        favoritos: "الأكثر طلباً",
        galeria: "معرض الصور",
        visitanos: "زورونا",
        reserva: "احجز طاولة",
      },
      lang: "اللغة",
    },
    hero: {
      title: "ابدأ يومك كما تحب",
      tagline: "برنش وقهوة مختصة · أليكانتي",
      ctaMenu: "تصفّح القائمة",
      ctaBook: "احجز طاولة",
    },
    about: {
      label: "فلسفتنا",
      title: "صباحات على مهل، وقهوة حقيقية",
      p1a: "في ديسيوس نعمل بقهوة مختصة ",
      p1strong: "عربية 100%",
      p1b: "، محمّصة على دفعات صغيرة ومستخلصة بالعناية التي تستحقها. كل فنجان ثمرة هوس هادئ: المنشأ، درجة التحميص، والحرارة الدقيقة.",
      p2: "مطبخنا يفتح كل صباح بمكونات طازجة من اليوم — خبز خارج من الفرن، فواكه موسمية، بيض، أفوكادو، سلمون. كل شيء يُحضَّر عند الطلب، ولا شيء ينتظر تحت المصباح.",
      quote: "صُنع بحب، من أجلك.",
      stats: [
        ["100%", "قهوة عربية"],
        ["9—18", "كل الأيام"],
        ["يومياً", "منتج طازج"],
      ],
      altInterior: "داخل مقهى ديسيوس",
      altLatte: "فن اللاتيه بقهوة مختصة",
    },
    carta: { label: "القائمة", title: "كل ما يُطبخ على مدار اليوم" },
    preparacion: {
      label: "كل صباح",
      title1: "لا شيء ينتظر في الثلاجة",
      title2: "طبقة فوق طبقة، لحظة طلبك",
      text: "خبز محمّص من اليوم، طماطم مبشورة يدوياً، جامون مقطّع رفيعاً وبيض مخفوق كريمي. يُركَّب أمامك في اللحظة، ولهذا يصل إلى الطاولة دافئاً.",
    },
    highlights: {
      label: "الأكثر طلباً",
      title: "ما يعود الناس لطلبه",
      intro: "أربعة أطباق تلخّص إلى حد بعيد روح ديسيوس.",
      cards: [
        { k: "حلو", t: "Bubble Waffle con helado", d: "مقرمشة من الخارج، هشّة من الداخل. مغطاة بالمثلجات والكريمة والإضافة التي تختارها." },
        { k: "مشروب", t: "Iced Matcha Latte", d: "ماتشا مخفوقة في اللحظة فوق حليب بارد وفاكهة طبيعية. منعشة، عشبية، لا تُقاوم." },
        { k: "توست", t: "Tostada de Aguacate", d: "خبز حرفي، طماطم طازجة، شرائح أفوكادو وبراعم صغيرة." },
        { k: "برنش", t: "Bocadillo con huevo", d: "خبز مقرمش، بيض على الصاج، جبن وخضار مشوية." },
      ],
    },
    gallery: { label: "معرض الصور", title: "لحظة في ديسيوس" },
    visit: {
      label: "زورونا",
      title: "ننتظركم في أليكانتي",
      addressLabel: "العنوان",
      hoursLabel: "أوقات العمل",
      hoursEveryDay: "كل الأيام",
      instagramLabel: "إنستغرام",
      mapsBtn: "افتح في خرائط جوجل",
      mapTitle: "خريطة ديسيوس برنش أند كوفي في أليكانتي",
      altTerrace: "مدخل ديسيوس برنش أند كوفي",
    },
    reserva: {
      label: "الحجز",
      title: "احجز طاولتك",
      intro: "في عطلة نهاية الأسبوع يمتلئ التراس بسرعة. أخبرنا متى تأتي وكم عددكم، ونترك لكم مكاناً في الظل.",
      nameLabel: "باسم",
      namePlaceholder: "اسمك",
      dayLabel: "اليوم",
      timeLabel: "الساعة",
      peopleLabel: "عدد الأشخاص",
      peopleMore: "9 أو أكثر",
      noteLabel: "شيء ينبغي أن نعرفه",
      notePlaceholder: "تراس، عربة أطفال، حساسية…",
      send: "أرسل عبر واتساب",
      hint: "سيُفتح واتساب والرسالة مكتوبة مسبقاً. ما عليك سوى إرسالها. نؤكد لك الطاولة فور قراءتها.",
      wa: {
        intro: "مرحباً! أود حجز طاولة في ديسيوس.",
        name: "الاسم",
        date: "التاريخ",
        time: "الساعة",
        people: "عدد الأشخاص",
        note: "ملاحظة",
      },
    },
    entrada: {
      label: "في آخر الشارع",
      title1: "تفضّل، نحن في انتظارك",
      title2: "وفي الداخل، رائحة القهوة",
      text: "ادخل متى شئت. نفتح كل يوم على التاسعة صباحاً.",
      btn: "كيف تصل إلينا",
    },
    footer: { hours: "كل الأيام 9:00 – 18:00", credit: "من إنجاز" },
  },

  ru: {
    nav: {
      home: "Наверх",
      menu: "Открыть меню",
      links: {
        "sobre-nosotros": "О нас",
        carta: "Меню",
        favoritos: "Любимое",
        galeria: "Галерея",
        visitanos: "Как найти",
        reserva: "Бронь",
      },
      lang: "Язык",
    },
    hero: {
      title: "Начните день так, как вам нравится",
      tagline: "Бранч и спешелти-кофе · Аликанте",
      ctaMenu: "Смотреть меню",
      ctaBook: "Забронировать столик",
    },
    about: {
      label: "Наша философия",
      title: "Неспешное утро и настоящий кофе",
      p1a: "В Deseos мы работаем со спешелти-кофе ",
      p1strong: "100 % арабика",
      p1b: ", обжаренным малыми партиями и приготовленным с должной заботой. Каждая чашка — результат спокойной одержимости: происхождение, степень обжарки, точная температура.",
      p2: "Наша кухня открывается каждое утро со свежими продуктами дня — хлеб из печи, сезонные фрукты, яйца, авокадо, лосось. Всё готовится на заказ, ничего не ждёт под лампой.",
      quote: "Сделано с любовью, для вас.",
      stats: [
        ["100%", "Арабика"],
        ["9—18", "Каждый день"],
        ["Ежедневно", "Свежие продукты"],
      ],
      altInterior: "Интерьер кафе Deseos",
      altLatte: "Латте-арт на спешелти-кофе",
    },
    carta: { label: "Меню", title: "Всё, что готовится в течение дня" },
    preparacion: {
      label: "Каждое утро",
      title1: "Ничего не ждёт в холодильнике",
      title2: "Слой за слоем — когда вы заказали",
      text: "Тост из свежего хлеба, тёртый вручную помидор, тонко нарезанный хамон и кремовая яичница. Всё собирается при вас, поэтому и приходит к столу тёплым.",
    },
    highlights: {
      label: "Любимое",
      title: "То, что заказывают снова",
      intro: "Четыре блюда, которые довольно точно передают дух Deseos.",
      cards: [
        { k: "Десерт", t: "Bubble Waffle con helado", d: "Хрустящая снаружи, воздушная внутри. С мороженым, сливками и топпингом на ваш выбор." },
        { k: "Напиток", t: "Iced Matcha Latte", d: "Матча, взбитая при вас, на холодном молоке со свежими фруктами. Свежо, травянисто, затягивает." },
        { k: "Тост", t: "Tostada de Aguacate", d: "Ремесленный хлеб, свежий помидор, авокадо ломтиками и микрозелень." },
        { k: "Бранч", t: "Bocadillo con huevo", d: "Хрустящий хлеб, яйцо на гриле, сыр и запечённые овощи." },
      ],
    },
    gallery: { label: "Галерея", title: "Время в Deseos" },
    visit: {
      label: "Как найти",
      title: "Ждём вас в Аликанте",
      addressLabel: "Адрес",
      hoursLabel: "Часы работы",
      hoursEveryDay: "Каждый день",
      instagramLabel: "Instagram",
      mapsBtn: "Открыть в Google Maps",
      mapTitle: "Карта Deseos Brunch & Coffee в Аликанте",
      altTerrace: "Вход в Deseos Brunch & Coffee",
    },
    reserva: {
      label: "Бронирование",
      title: "Оставьте столик за собой",
      intro: "По выходным терраса заполняется быстро. Скажите, когда придёте и сколько вас, — оставим место в тени.",
      nameLabel: "На имя",
      namePlaceholder: "Ваше имя",
      dayLabel: "День",
      timeLabel: "Время",
      peopleLabel: "Гостей",
      peopleMore: "9 и больше",
      noteLabel: "Что нам стоит знать",
      notePlaceholder: "Терраса, коляска, аллергии…",
      send: "Отправить в WhatsApp",
      hint: "WhatsApp откроется с уже готовым сообщением. Останется только отправить. Подтвердим столик, как только прочитаем.",
      wa: {
        intro: "Здравствуйте! Хочу забронировать столик в Deseos.",
        name: "Имя",
        date: "Дата",
        time: "Время",
        people: "Гостей",
        note: "Примечание",
      },
    },
    entrada: {
      label: "В конце улицы",
      title1: "Заходите, мы вас ждём",
      title2: "А внутри пахнет кофе",
      text: "Заходите в любое время. Открываемся каждый день в девять.",
      btn: "Как добраться",
    },
    footer: { hours: "Каждый день 9:00 – 18:00", credit: "Сделано" },
  },
};
